<template>
    <div container--fluid>
        <v-layout>
            <CheckoutModule></CheckoutModule>
        </v-layout>
    </div>
</template>

<script>
import CheckoutModule from "@modules/product/checkout.vue";

export default {
    name: "checkout",
    components: {
        CheckoutModule,
    },
    data() {
        return {
            //
        };
    },
};
</script>

<style scoped></style>
